const allModulePermission = (state = {}, action) => {
    if (action.type === "modulePermission") {
      return (state = action.payload);
    } else {
      return state;
    }
  };
  export default allModulePermission;
  